import { listRewardCategories } from "../../../graphql/queries/listRewardCategories";
import { listTiers } from "../../../graphql/queries/listTiers";

export const dropdownQueryRegistry = {
  listRewardCategories,
  listTiers,
};
